<template>
<div class="lesson" :style="{paddingTop: headerHeight + 'px'}" v-loading="pageLoading">
  <SubHeader :showUser="true"></SubHeader>
  <div class="box-line" id="line"></div>
  <div class="lesson-content" :style="{height: `calc(100vh - ${headerHeight}px)`}">
    <div class="classify">
      <div class="classify-item ellipsis" v-for="(item, index) of category" :key="item.id" @click="getList(index)" :class="{ 'classify-item_active': classify == index }">
        {{ item.category_name }}
      </div>
    </div>
    <div class="list" v-if="category.length">
      <div class="list-name ellipsis" style="magrin-top: 200px">
        {{ category[classify] && category[classify].category_name }}
      </div>
      <van-list class="scroll-content" v-loading="listLoading" v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了">
        <SmallPriceCard v-for="item of list" :key="item.id" @click.native="jumpDetail(item)" :cardData="item"></SmallPriceCard>
      </van-list>
      <van-empty style="margin: 0 auto" v-if="!list.length" description="暂无数据" />
    </div>
  </div>
</div>
</template>

<script>
import SmallPriceCard from "@/components/SmallPriceCard";
import VideoCard from "@/components/VideoCard";
import TopCard from "@/components/TopCard";
import SubHeader from "@/components/SubHeader";
import LiveCard from "@/components/LiveCard";

export default {
  name: "lesson",
  components: {
    SmallPriceCard,
    VideoCard,
    TopCard,
    SubHeader,
    LiveCard,
  },
  data() {
    return {
      active: 0,
      list: [],
      tag: 1,
      classify: 0,
      category: [],
      loading: false,
      pageLoading: true,
      finished: true,
      more: false,
      ideaNavData: [],
      ideaAllData: [],
      listLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  destroyed() {
  },
  computed: {
    plat() {
      return this.$store.state.plat_id;
    },
    headerHeight() {
      return this.$store.state.headerHeight;
    }
  },
  methods: {
    async getList(index) {
      console.log(index)
      this.listLoading = true;
      this.classify = index;
      let res = await this.$api({
        method: "get",
        url: "/api/platform/category/list",
        data: {
          category_id: this.category[this.classify].category_id,
          flat_id: this.plat,
          // is_interior: 1,
        },
      });
      this.listLoading = false;
      if (res.code == 0) {
        this.list = res.data.list;
      } else {
        this.$toast(res.msg);
      }
    },
    async getData() {
      this.pageLoading = true;
      let res = await this.$api({
        method: "get",
        url: "/api/platform/shi/category",
        data: {
          flat_id: this.plat,
        },
      });
      this.pageLoading = false;
      if (res.code == 0) {
        this.topData = res.data.top_list;
        this.category = res.data;
        await this.getList(
          this.$route.query.index ? this.$route.query.index : 0
        );
      } else {
        this.$toast(res.msg);
      }
    },
    jumpDetail(item) {
      this.$router.push(`./detail?id=${item.id}`);
    },
    getMore() {
      if (this.more) {
        return;
      }
      this.more = true;
      if (this.menu == 2) {
        axios
          .get(
            `/api/platform/shi/category?flat_id=${this.plat}&page=${this.page}`, {}
          )
          .then((res) => {
            this.more = false;
            console.log(res);
            if (res.code == 0) {
              let list = res.data.category[this.classify].goods;
              this.list = this.list.concat(list);
              this.loading = false;
              if (list.length < 10) {
                this.finished = true;
              } else {
                this.finished = false;
              }
            } else {
              this.$toast(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.more = false;
          });
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate");
    console.log(to);
    next();
  },
};
</script>

<style lang="scss" scoped>
.lesson {
  min-height: calc(100vh - 230px);
  display: flex;
  align-items: flex-start;
  overflow: hidden;

  .lesson-content {
    flex: 0 1 auto;
    width: 100%;
    display: flex;
    box-sizing: border-box;
  }

  .lesson-content .classify {
    flex: 0 0 172px;
    height: 100%;
    width: 172px;
    box-sizing: border-box;
  }

  .lesson-content .list {
    flex: 0 1 auto;
    min-height: 100vh;
    width: 100%;
    background: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .lesson-content .classify-item {
    width: 142px;
    height: 50px;
    border-radius: 31px;
    color: #333;
    font-size: 26px;
    line-height: 50px;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 45px auto;
    text-align: center;
  }

  .lesson-content .classify-item:last-of-type {
    margin-bottom: 40px;
  }

  .lesson-content .classify-item_active {
    width: 142px;
    height: 50px;
    background: #a7090a;
    border-radius: 31px;
    color: #fff;
  }

  .lesson-content .list-name {
    height: 89px;
    line-height: 89px;
    color: #333;
    font-size: 34px;
    width: 538px;
  }

  .lesson-content .scroll-content {
    height: calc(100% - 89px);
    background: #fff;
    overflow: auto;
    border-radius: 12px;
    border-radius: 1px solid #eee;
    padding: 20px 0;
    box-sizing: border-box;
  }

  .lesson-content .classify-item:last-of-type,
  .lesson-content .card:last-of-type {
    margin-bottom: 100px;
  }
}
</style>

<style lang="scss">
</style>
